import { Container } from '@/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentsWebPage.module.scss';
import DocumentsWeb from '../DocumentsWeb';

const DocumentsWebPage: FC = () => {
  const { t } = useTranslation('documentWeb');

  return (
    <Container title={t('title')} className={styles.container}>
      <DocumentsWeb />
    </Container>
  );
};

export default DocumentsWebPage;
